import { AnalysisRemarkItemDto, AnalysisRemarkStateDto } from '@/api/generated';
import { AnalysisRemarksSearchFormModel } from '@/views/analysisRemarks/model/AnalysisRemarksSearchForm.model.ts';

export type AnalysisRemarksViewTranslation = {
  body: {
    comments: string;
    open: string;
    stateOptions: Record<AnalysisRemarkStateDto, string>;
  };
  buttons: {
    importExternalRecruitments: string;
    showActive: string;
  };
  columns: Record<
    keyof Omit<
      AnalysisRemarkItemDto,
      'analysisRemarkId' | 'candidateFirstName' | 'candidateId' | 'candidateLastName' | 'processId'
    >,
    string
  > & {
    actions: string;
    candidate: string;
    process: string;
  };
  commentsDialog: {
    buttons: {
      cancel: string;
      submit: string;
      submitAndVerify: string;
    };
    field: string;
    instruction: string;
    noResults: string;
    placeholder: string;
    submitAndVerifyDisabledHint: string;
    title: string;
  };
  filters: Record<keyof AnalysisRemarksSearchFormModel, string>;
};

export const analysisRemarksViewTranslation: AnalysisRemarksViewTranslation = {
  body: {
    comments: 'Comments',
    open: 'Open',
    stateOptions: {
      [AnalysisRemarkStateDto.Done]: 'Done',
      [AnalysisRemarkStateDto.InProgress]: 'In Progress',
      [AnalysisRemarkStateDto.New]: 'New',
      [AnalysisRemarkStateDto.Seen]: 'Seen',
      [AnalysisRemarkStateDto.ToVerify]: 'To verify',
    },
  },
  buttons: {
    importExternalRecruitments: 'Import processes from eRecruiter',
    showActive: 'Show active',
  },
  columns: {
    actions: 'Actions',
    candidate: 'Candidate',
    content: 'Remark',
    createdAt: 'Date',
    createdBy: 'Author',
    process: 'Process',
    state: 'State',
  },
  commentsDialog: {
    buttons: {
      cancel: 'Cancel',
      submit: 'Add comment',
      submitAndVerify: 'Add and mark for verification',
    },
    field: 'Comment',
    instruction: 'Review the discussion and add a new comment to this remark.',
    noResults: 'No comments yet.',
    placeholder: 'Enter your comment',
    submitAndVerifyDisabledHint: 'Available when the remark is in "Seen" or "In Progress" state.',
    title: 'Comments',
  },
  filters: {
    searchPhrase: 'Search remarks...',
    statuses: 'Statuses',
  },
};
